import { ICON_SIZE_MAP } from '@/config';

export const ROW_1_HEIGHT = 42;
export const META_ROW_HEIGHT = 36;
export const ICON_SIZE = ICON_SIZE_MAP.sm;
export const META_ITEM_VALUE_MAX_WIDTH = 150;
export const META_ITEM_LOADER_WIDTH = 50;
export const TITLE_MAX_WIDTH = 620;
